import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { makeRequest } from "../common/customServiceCall/serviceCall";


export const TransactionReprocessingForm = (props) => {
  const toast = useRef(null);
  const labelStyle = {
    paddingLeft: "10px",
    fontSize: "12px",
    color: "#999",
    fontWeight: "500",
  };

  // Extract instId from URL
  // const url = window.location.href;
  // const instId = url.substring(url.lastIndexOf("/") + 1);
  const instId = sessionStorage.getItem("selectedInstitutionId")
  // Initialize form data state
  const [formData, setFormData] = useState({
    id: "",
    institutionId: instId, // Set instId in initial state
    maxAttempts: "",
    onLimitReached: "",
    createdAt: "",
    modifiedAt: "",
  });
  const [isFormEmpty, setIsFormEmpty] = useState(true);
  const [showButtons, setShowButtons] = useState(false);
  const [disable, setDisable] = useState(false);
  const [disableFormField, setDisableFormField] = useState(false);

  useEffect(() => {
    // Check if props.data exists and is not empty
    if (props.data && Object.keys(props.data).length > 0) {
      setFormData({
        id: props.data.id || "",
        institutionId: props.data.institutionId || instId, // Use props.data.institutionId or fallback to instId
        maxAttempts: props.data.maxAttempts || "",
        onLimitReached: props.data.onLimitReached || "",
        createdAt: props.data.createdAt || "",
        modifiedAt: props.data.modifiedAt || "",
      });

      // Determine if form is empty
      const allFieldsEmpty = !props.data.id 
                             
      setIsFormEmpty(allFieldsEmpty);
      setDisableFormField(!allFieldsEmpty);
    } else {
      // Reset form data if no props.data
      setFormData({
        id: "",
        institutionId: instId,
        maxAttempts: "",
        onLimitReached: "",
        createdAt: "",
        modifiedAt: "",
      });
      setIsFormEmpty(true);
      setDisableFormField(false);
    }
  }, [props.data, instId]);

  // Event handlers
  const handleModify = (event) => {
    event.preventDefault();
    setDisable(true);
    setShowButtons(true);
    setDisableFormField(false);
  };

  const handleCancel = (event) => {
    event.preventDefault();
    setDisable(false);
    setShowButtons(false);
    setDisableFormField(true);
  };

  const clientCallAddKYCReprocessingConfig = async (event) => {
    event.preventDefault();
    const { institutionId, onLimitReached, maxAttempts } = formData;
    const payload = { institutionId, onLimitReached, maxAttempts };

    sessionStorage.setItem("newData", JSON.stringify(payload));

    try {
      const response = await makeRequest("post", "kres/api/v1/kycreprocess/evaluation", payload);
      if (response.code === "00") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
          life: 3000,
        });
        setTimeout(() => window.location.reload(), 3000);
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.message,
          life: 3000,
        });

      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const handleSave = async (event) => {
    event.preventDefault();
    const { institutionId, onLimitReached, maxAttempts, id } = formData;
    const payload = { id, institutionId, onLimitReached, maxAttempts };

    try {
      const response = await makeRequest("put", "kres/api/v1/kycreprocess/evaluation", payload);
      if (response.code === "00") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
          life: 3000,
        });
        setTimeout(() => window.location.reload(), 3000);
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.message,
          life: 3000,
        });
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const handleDelete = async (event) => {
    event.preventDefault();
    const { institutionId } = formData;
    try {
      const response = await makeRequest("delete", `kres/api/v1/kycreprocess/evaluation/${institutionId}`);
      if (response.code === "00") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
          life: 3000,
        });
        setTimeout(() => window.location.reload(), 3000);
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.message,
          life: 3000,
        });
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDropdownChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      onLimitReached: e.value,
    }));
  };

  const options = [
    { label: "BACK OFF", value: "BACK_OFF" },
    { label: "FAIL", value: "FAIL" },
  ];

  const layout = {
    backgroundColor: "white",
    padding: "20px 0px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  };

  return (
    <div style={layout}>
      <form style={{ width: "500px" }}>
        <>
          {!isFormEmpty && (
            <div className="topUp p-my-5">
              <span className="p-float-label">
                <InputText
                  value={formData.id}
                  onChange={handleChange}
                  style={{ width: "100%" }}
                  name="id"
                  type="text"
                  disabled={disable || disableFormField}
                />
                <label htmlFor="inputtext" style={labelStyle}>
                  Id
                </label>
              </span>
            </div>
          )}

          <div className="topUp p-my-5">
            <span className="p-float-label">
              <InputText
                value={formData.institutionId} // Bind to formData.institutionId
                onChange={handleChange}
                style={{ width: "100%" }}
                disabled={true}
                name="institutionId"
                type="text"
              />
              <label htmlFor="inputtext" style={labelStyle}>
                Institution Id
              </label>
            </span>
          </div>

          <div className="topUp p-my-5">
            <span className="p-float-label">
              <InputText
                value={formData.maxAttempts}
                onChange={handleChange}
                style={{ width: "100%" }}
                name="maxAttempts"
                type="text"
                disabled={disableFormField}
              />
              <label htmlFor="inputtext" style={labelStyle}>
                Maximum Number of Attempts
              </label>
            </span>
          </div>

          <div className="topUp p-my-5">
            <span className="p-float-label">
              <Dropdown
                optionLabel="label"
                value={formData.onLimitReached}
                onChange={handleDropdownChange}
                style={{ width: "100%" }}
                autoWidth={true}
                options={options}
                placeholder=""
                disabled={disableFormField}
              />
              <label htmlFor="dropdown1" style={labelStyle}>
                On Limit Reached
              </label>
            </span>
          </div>

          {!isFormEmpty && (
            <div className="topUp p-my-5">
              <span className="p-float-label">
                <InputText
                  value={formData.createdAt}
                  onChange={handleChange}
                  style={{ width: "100%" }}
                  name="createdAt"
                  type="text"
                  disabled={disable || disableFormField}
                />
                <label htmlFor="inputtext" style={labelStyle}>
                  Created At
                </label>
              </span>
            </div>
          )}

          {!isFormEmpty && (
            <div className="topUp p-my-5">
              <span className="p-float-label">
                <InputText
                  value={formData.modifiedAt}
                  onChange={handleChange}
                  style={{ width: "100%" }}
                  name="modifiedAt"
                  type="text"
                  disabled={disable || disableFormField}
                />
                <label htmlFor="inputtext" style={labelStyle}>
                  Modified At
                </label>
              </span>
            </div>
          )}
        </>

        <div style={{ display: "flex", gap: "10px", paddingBottom: "10px" }}>
          {isFormEmpty ? (
            <Button
              className="p-button-info"
              label="Add"
              onClick={clientCallAddKYCReprocessingConfig}
            />
          ) : (
            <>
              {showButtons ? (
                <div style={{ display: "flex", gap: "10px" }}>
                  <Button
                    className="p-button-info"
                    label="Save"
                    onClick={handleSave}
                  />
                  <Button
                    className="p-button-info"
                    label="Cancel"
                    onClick={handleCancel}
                  />
                </div>
              ) : (
                <div style={{ display: "flex", gap: "10px" }}>
                  <Button
                    className="p-button-info"
                    label="Modify"
                    onClick={handleModify}
                  />
                  <Button
                    className="p-button-info"
                    label="Delete"
                    onClick={handleDelete}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </form>
      <Toast ref={toast} />
    </div>
  );
};
